// extracted by mini-css-extract-plugin
export default {"side-image":"LoginWithToken_side-image__tn8Cp"};